import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import CRHome from "./pages/CRHome";
import RosterConnect from "./pages/RosterConnect";
import RosterPrivacy from "./pages/RosterPrivacy";
import RosterTerms from "./pages/RosterTerms";
import RosterSupport from "./pages/RosterSupport";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<CRHome />} />
        <Route path="/roster-connect" element={<RosterConnect />} />
        <Route path="/roster-connect/privacy" element={<RosterPrivacy />} />
        <Route path="/roster-connect/terms" element={<RosterTerms />} />
        <Route path="/roster-connect/support" element={<RosterSupport />} />
      </Routes>
    </>
  );
}
